let cachedToken = null;
let cachedAt = 0;
const TOKEN_TTL_MS = 55_000;

function getAuth() {
  // Lazy-access Firebase compat auth — avoids import-time crash before init
  const app = require('firebase/compat/app').default || require('firebase/compat/app');
  return app.auth();
}

export async function getAuthToken(forceRefresh = false) {
  const now = Date.now();
  if (!forceRefresh && cachedToken && (now - cachedAt) < TOKEN_TTL_MS) {
    return cachedToken;
  }
  try {
    const user = getAuth().currentUser;
    if (!user) return null;
    cachedToken = await user.getIdToken(forceRefresh);
    cachedAt = now;
    return cachedToken;
  } catch {
    return null;
  }
}

export function clearAuthToken() {
  cachedToken = null;
  cachedAt = 0;
}
